/**
 * Status chip colours, the same five as HCP's status pills and Traceability's
 * chips:
 * - red (danger): a check failed, or something was rejected or deleted;
 * - amber (warning): needs someone to act, such as pending review, partial
 *   data or a mitigation still under way;
 * - green (success): clear, accepted or done;
 * - blue (info): for information, such as which risks were detected;
 * - grey (neutral): no data, or draft.
 * `compliant`, `non-compliant` and `partial` are older names for success,
 * danger and warning.
 */
export type ChipVariant =
  | 'success'
  | 'warning'
  | 'danger'
  | 'neutral'
  | 'info'
  | 'compliant'
  | 'non-compliant'
  | 'partial';

/**
 * Every status chip's colour, in one place. Read by `getComplianceProps`,
 * `getMitigationStatusChipProps` and the plot-linking pages.
 */
export const STATUS_CHIP_VARIANT = {
  // Risk rating
  compliant: 'success',
  nonCompliant: 'danger',
  partialData: 'warning',
  noData: 'neutral',
  // A flagged risk is information, not an error: detection is what the
  // platform is for, and the flag stays after mitigation. The mitigation chip
  // says whether anything still needs doing. A clear check is green.
  riskFlagged: 'info',
  riskClear: 'success',
  // Risk verification and mitigation
  mitigationOngoing: 'warning',
  selfVerified: 'success',
  // Plot linking: submissions and imports
  pending: 'warning',
  accepted: 'success',
  rejected: 'danger'
} as const satisfies Record<string, ChipVariant>;
